import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_PREFIX,
  GET_PREFIXES,
  ADD_PREFIX,
  UPDATE_PREFIX,
  DELETE_PREFIX
} from '@/queries/modules/common-data/prefix';

export async function getPrefixes(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PREFIXES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setPrefixes', data.getPrefixes);
      context.commit('setSuccess', null);
      return data.getPrefixes
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getPrefix(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PREFIX,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setPrefix', data.getPrefix);
      context.commit('setSuccess', null);
      return data.getPrefix
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addPrefix(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_PREFIX,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const prefixes = [...context.state.prefixes];
      prefixes.push(data.addPrefix);
      context.commit('setPrefixes', prefixes);
      context.commit('setSuccess', newItemSuccess(data.addPrefix.nameLocal));

      return data.addPrefix
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updatePrefix(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PREFIX,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.prefixes.findIndex(item => item.id === data.updatePrefix.id);
      const prefixes = [
        ...context.state.prefixes.slice(0, index),
        data.updatePrefix,
        ...context.state.prefixes.slice(index + 1)
      ];
      context.commit('setPrefixes', prefixes);
      context.commit('setSuccess', updateItemSuccess(data.updatePrefix.nameLocal));

      return data.updatePrefix
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deletePrefix(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_PREFIX,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.prefixes.findIndex(item => item.id === data.deletePrefix.id);
      const prefixes = [
        ...context.state.prefixes.slice(0, index),
        ...context.state.prefixes.slice(index + 1)
      ];
      context.commit('setPrefixes', prefixes);
      context.commit('setSuccess', deleteItemSuccess(data.deletePrefix.nameLocal));

      return data.deletePrefix
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

